import { Link, Navigate } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import { useT } from "@/lib/i18n";
import { LangToggle } from "@/components/common";

const HERO = "https://images.unsplash.com/photo-1660631228116-b3643559f611?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function AuthPage({ mode }) {
  const { t } = useT();
  return (
    <div className="min-h-screen bg-[#09090B] flex">
      <Show when="signed-in"><Navigate to="/dashboard" replace /></Show>
      <div className="hidden lg:flex relative w-1/2 grain overflow-hidden">
        <img src={HERO} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#09090B]/70" />
        <div className="relative z-10 flex flex-col justify-between p-12">
          <Link to="/" className="font-display font-extrabold text-xl" data-testid="auth-brand-link">IAGORA <span className="text-indigo-400">AI LIVE</span></Link>
          <div>
            <p className="eyebrow mb-4">{t("auth_eyebrow")}</p>
            <h2 className="font-display text-5xl font-black tracking-tight leading-[1.05] max-w-md">{t("auth_title")}</h2>
          </div>
        </div>
      </div>
      <div className="flex-1 flex flex-col">
        <div className="flex justify-between items-center p-6">
          <Link to="/" className="lg:invisible font-display font-extrabold">IAGORA <span className="text-indigo-400">AI LIVE</span></Link>
          <LangToggle />
        </div>
        <div className="flex-1 flex items-center justify-center p-4" data-testid={`${mode}-container`}>
          {mode === "sign-in" ? (
            <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" forceRedirectUrl="/dashboard" signUpForceRedirectUrl="/dashboard" withSignUp />
          ) : (
            <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" forceRedirectUrl="/dashboard" signInForceRedirectUrl="/dashboard" />
          )}
        </div>
      </div>
    </div>
  );
}
